export const BACKEND_ERRORS = { email_taken: 'The email has already been taken.' };
